/*
 *  Custom Tag Filter
 *    - Extends the ajax collection tag filter class
 *
 *  Version:
 *    1.0.0 - 2022/04/01
 */

import { TagFilter } from '@process-creative/slate-ajax-collection';

export class CustomTagFilter extends TagFilter {
  filterAnd(product) {
    if (!this.tags.length) return true;
    const searchTag = this.tags[this.tags.length - 1];
    return product.tags.includes(searchTag);
  }

  removeTag() {
    // not implemented
  }

  addTag(tag) {
    if (this.getSetting(tag)) return;
    this.tags = [tag.toLowerCase()];
    this.filters.onFilterUpdate();
  }
}
